// export const api_url = 'http://software-exchange-be.test';
export const api_url = 'http://software-exchange-be.hiteclogs.com';
export const stripe_key = 'pk_test_51MmdUJDaL24gTBYOYkOQ6SkGPyUtkXJEvIoLWzXtTXqJuDQv8rNWLKAbaX50JRPxUOFoUmdPMFoUW1lqIinJUlZs007116L74U'
export const defaultHeaders = {
    "Content-Type": "application/json",
    "Accept": "application/json"
}